<p-dialog
  [(visible)]="visible"
  [baseZIndex]="3000"
  [closable]="true"
  [contentStyle]="{ overflow: 'visible' }"
  [dismissableMask]="true"
  [modal]="true"
  [style]="{ width: '42rem', maxWidth: '95vw' }"
>
  <ng-template pTemplate="header">
    <div class="dialog-header-copy">
      <h3>{{ isEditMode ? 'Kundennutzer bearbeiten' : 'Neuen Kundennutzer anlegen' }}</h3>
      @if (isRecoveryMode) {
        <p class="dialog-disclaimer">{{ recoveryHint }}</p>
      }
    </div>
  </ng-template>

  <hr class="divider" />
  <div class="dialog-inputs">
    @if (!isEditMode) {
      <div class="field">
        <span>E-Mail <span class="required">*</span></span>
        <div class="field-input">
          <input
            type="email"
            pInputText
            [(ngModel)]="email"
            (ngModelChange)="clearFormErrors()"
            placeholder="E-Mail-Adresse"
            [maxlength]="emailMaxLength"
            [class.input-invalid]="!!emailErrorMessage || isEmailMaxLengthReached()"
          />
          @if (emailErrorMessage) {
            <div class="field-error">{{ emailErrorMessage }}</div>
          }
          @if (!emailErrorMessage && isEmailMaxLengthReached()) {
            <div class="field-error">{{ maxLengthReachedMessage }}</div>
          }
        </div>
      </div>
      <div class="field">
        <span>Kunde <span class="required">*</span></span>
        <p-dropdown
          [options]="customerOptions"
          [(ngModel)]="selectedCustomerId"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          [showClear]="true"
          placeholder="Kunden auswählen"
          [appendTo]="'body'"
          [disabled]="loading"
        ></p-dropdown>
      </div>
      <div class="field">
        <span>Vorname</span>
        <div class="field-input">
          <input
            type="text"
            pInputText
            [(ngModel)]="firstName"
            (ngModelChange)="clearFormErrors()"
            placeholder="Vorname"
            [maxlength]="nameMaxLength"
            [class.input-invalid]="!!firstNameErrorMessage || isFirstNameMaxLengthReached()"
          />
          @if (firstNameErrorMessage) {
            <div class="field-error">{{ firstNameErrorMessage }}</div>
          }
          @if (!firstNameErrorMessage && isFirstNameMaxLengthReached()) {
            <div class="field-error">{{ maxLengthReachedMessage }}</div>
          }
        </div>
      </div>
      <div class="field">
        <span>Nachname</span>
        <div class="field-input">
          <input
            type="text"
            pInputText
            [(ngModel)]="lastName"
            (ngModelChange)="clearFormErrors()"
            placeholder="Nachname"
            [maxlength]="nameMaxLength"
            [class.input-invalid]="!!lastNameErrorMessage || isLastNameMaxLengthReached()"
          />
          @if (lastNameErrorMessage) {
            <div class="field-error">{{ lastNameErrorMessage }}</div>
          }
          @if (!lastNameErrorMessage && isLastNameMaxLengthReached()) {
            <div class="field-error">{{ maxLengthReachedMessage }}</div>
          }
        </div>
      </div>
    } @else {
      <div class="field">
        <span>E-Mail</span>
        <div class="field-input">
          <input
            type="email"
            pInputText
            [(ngModel)]="email"
            (ngModelChange)="clearFormErrors()"
            placeholder="E-Mail-Adresse (optional)"
            [maxlength]="emailMaxLength"
            [class.input-invalid]="!!emailErrorMessage || isEmailMaxLengthReached()"
          />
          @if (emailErrorMessage) {
            <div class="field-error">{{ emailErrorMessage }}</div>
          }
          @if (!emailErrorMessage && isEmailMaxLengthReached()) {
            <div class="field-error">{{ maxLengthReachedMessage }}</div>
          }
        </div>
      </div>
      <div class="field">
        <span>Kunde <span class="required">*</span></span>
        <div class="field-input read-only-value">{{ selectedCustomerLabel }}</div>
      </div>
      <div class="field">
        <span>Vorname</span>
        <div class="field-input">
          <input
            type="text"
            pInputText
            [(ngModel)]="firstName"
            (ngModelChange)="clearFormErrors()"
            placeholder="Vorname"
            [maxlength]="nameMaxLength"
            [class.input-invalid]="!!firstNameErrorMessage || isFirstNameMaxLengthReached()"
          />
          @if (firstNameErrorMessage) {
            <div class="field-error">{{ firstNameErrorMessage }}</div>
          }
          @if (!firstNameErrorMessage && isFirstNameMaxLengthReached()) {
            <div class="field-error">{{ maxLengthReachedMessage }}</div>
          }
        </div>
      </div>
      <div class="field">
        <span>Nachname</span>
        <div class="field-input">
          <input
            type="text"
            pInputText
            [(ngModel)]="lastName"
            (ngModelChange)="clearFormErrors()"
            placeholder="Nachname"
            [maxlength]="nameMaxLength"
            [class.input-invalid]="!!lastNameErrorMessage || isLastNameMaxLengthReached()"
          />
          @if (lastNameErrorMessage) {
            <div class="field-error">{{ lastNameErrorMessage }}</div>
          }
          @if (!lastNameErrorMessage && isLastNameMaxLengthReached()) {
            <div class="field-error">{{ maxLengthReachedMessage }}</div>
          }
        </div>
      </div>
    }
    @if (formErrorMessage && !(emailErrorMessage && !isEditMode)) {
      <div class="form-error-banner">{{ formErrorMessage }}</div>
    }
  </div>
  <hr class="divider" />
  <div class="dialog-actions">
    @if (isEditMode && !allowDeactivate && !isRecoveryMode) {
      <app-button
        (click)="onClickReactivate()"
        type="secondary-button"
        label="Aktivieren"
      />
    }
    @if (isEditMode && allowDeactivate && !isRecoveryMode) {
      <app-button
        (click)="onClickDelete()"
        type="primary-button-red"
        label="Deaktivieren"
      />
    }
    @if (isEditMode && (!allowDeactivate || isRecoveryMode)) {
      <app-button
        (click)="onClickPermanentDelete()"
        type="primary-button-red"
        label="Löschen"
      />
    }
    <app-button (click)="close()" label="Abbrechen" type="secondary-button" />
    <app-button
      (click)="save()"
      [disabled]="!canSave"
      label="Speichern"
      type="primary-button"
    />
  </div>

  @if (showReactivateConfirm) {
    <p-dialog
      [modal]="true"
      [(visible)]="showReactivateConfirm"
      [style]="{ width: '28rem' }"
      [closable]="false"
      [appendTo]="'body'"
      [baseZIndex]="4000"
    >
      <ng-template pTemplate="header">
        <h3>Kundennutzer aktivieren?</h3>
      </ng-template>
      <p>Der Kundennutzer wird wieder in den aktiven Tab verschoben.</p>
      <div class="dialog-buttons">
        <app-button (click)="cancelReactivate()" type="secondary-button" label="Abbrechen" />
        <app-button (click)="confirmReactivate()" type="primary-button" label="Ja, aktivieren" />
      </div>
    </p-dialog>
  }

  @if (showDeleteConfirm) {
    <p-dialog
      [modal]="true"
      [(visible)]="showDeleteConfirm"
      [style]="{ width: '28rem' }"
      [closable]="false"
      [appendTo]="'body'"
      [baseZIndex]="4000"
    >
      <ng-template pTemplate="header">
        <h3>Kundennutzer deaktivieren?</h3>
      </ng-template>
      <p>Der Kundennutzer wird in den deaktivierten Tab verschoben.</p>
      <div class="dialog-buttons">
        <app-button (click)="cancelDelete()" type="secondary-button" label="Abbrechen" />
        <app-button (click)="confirmDelete()" type="primary-button-red" label="Ja, deaktivieren" />
      </div>
    </p-dialog>
  }

  @if (showPermanentDeleteConfirm) {
    <p-dialog
      [modal]="true"
      [(visible)]="showPermanentDeleteConfirm"
      [style]="{ width: '28rem' }"
      [closable]="false"
      [appendTo]="'body'"
      [baseZIndex]="4000"
    >
      <ng-template pTemplate="header">
        <h3>{{ isRecoveryMode ? 'Kundennutzer löschen?' : 'Kundennutzer endgültig löschen?' }}</h3>
      </ng-template>
      @if (isRecoveryMode) {
        <p>Sind Sie sicher, dass Sie diesen Kundennutzer löschen möchten?</p>
        <p>Der Kundennutzer wird direkt aus der Datenbank entfernt. Dieser Vorgang kann nicht rückgängig gemacht werden.</p>
      } @else {
        <p>Sind Sie sicher, dass Sie diesen Kundennutzer löschen möchten?</p>
        <p>Der deaktivierte Kundennutzer wird dauerhaft entfernt. Dieser Vorgang kann nicht rückgängig gemacht werden.</p>
      }
      <div class="dialog-buttons">
        <app-button (click)="cancelPermanentDelete()" type="secondary-button" label="Abbrechen" />
        <app-button (click)="confirmPermanentDelete()" type="primary-button-red" label="Löschen" />
      </div>
    </p-dialog>
  }
</p-dialog>
